import { createActions, createReducer } from 'reduxsauce'

const { Types, Creators } = createActions({
  createRulesRequest: ['data'],
  createRulesSuccess: ['data'],
  createRulesFailure: ['error'],
  fetchRulesRequest: null,
  fetchRulesSuccess: ['data'],
  fetchRulesFailure: ['error'],
  updateRulesRequest: ['data'],
  updateRulesSuccess: ['data'],
  updateRulesFailure: ['error'],
})

export const UserRulesTypes = Types
export const UserRulesActions = Creators

const INITIAL_STATE = {
  createRulesLoading: false,
  fetchRulesLoading: false,
  updateRulesLoading: false,
  userRules: null,
  createRulesSuccess: null,
  updateRulesSuccess: null,
  error: null,
}

const createRulesRequest = (state) => ({
  ...state,
  createRulesLoading: true,
  createRulesSuccess: null,
  error: null,
})

const createRulesSuccess = (state, action) => ({
  ...state,
  createRulesLoading: false,
  userRules: action.data,
  createRulesSuccess: action.data,
})

const createRulesFailure = (state, action) => ({
  ...state,
  createRulesLoading: false,
  error: action.error,
})

const fetchRulesRequest = (state) => ({
  ...state,
  fetchRulesLoading: true,
  error: null,
})

const fetchRulesSuccess = (state, action) => ({
  ...state,
  fetchRulesLoading: false,
  userRules: action.data,
})

const fetchRulesFailure = (state) => ({
  ...state,
  fetchRulesLoading: false,
})

const updateRulesRequest = (state) => ({
  ...state,
  updateRulesLoading: true,
  updateRulesSuccess: null,
  error: null,
})

const updateRulesSuccess = (state, action) => ({
  ...state,
  updateRulesLoading: false,
  userRules: action.data,
  updateRulesSuccess: action.data,
})

const updateRulesFailure = (state, action) => ({
  ...state,
  updateRulesLoading: false,
  error: action.error,
})

const reset = () => INITIAL_STATE

export default createReducer(INITIAL_STATE, {
  [Types.CREATE_RULES_REQUEST]: createRulesRequest,
  [Types.CREATE_RULES_SUCCESS]: createRulesSuccess,
  [Types.CREATE_RULES_FAILURE]: createRulesFailure,
  [Types.FETCH_RULES_REQUEST]: fetchRulesRequest,
  [Types.FETCH_RULES_SUCCESS]: fetchRulesSuccess,
  [Types.FETCH_RULES_FAILURE]: fetchRulesFailure,
  [Types.UPDATE_RULES_REQUEST]: updateRulesRequest,
  [Types.UPDATE_RULES_SUCCESS]: updateRulesSuccess,
  [Types.UPDATE_RULES_FAILURE]: updateRulesFailure,
})
